module.exports = __webpack_public_path__ + "img/youtube-play.77bbd555.svg";